var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 666.7 681.1",
    style: {
      enableBackground: "new 0 0 666.7 681.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:66.6667;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:133.3333;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.7,214.4V97.8c0-27.7,0-41.6-5.8-50.1c-5.1-7.4-13-12.5-21.9-14c-10.2-1.7-22.8,4.1-47.9,15.7L95.3,185.8 c-22.5,10.4-33.7,15.5-41.9,23.6c-7.3,7.1-12.8,15.8-16.2,25.4c-3.8,10.8-3.8,23.2-3.8,47.9v165.1 M483.3,431.1h0.3 M33.3,321.1v220 c0,37.3,0,56,7.3,70.3c6.4,12.5,16.6,22.7,29.1,29.1c14.3,7.3,32.9,7.3,70.3,7.3h386.7c37.3,0,56,0,70.3-7.3 c12.5-6.4,22.7-16.6,29.1-29.1c7.3-14.3,7.3-32.9,7.3-70.3v-220c0-37.3,0-56-7.3-70.3c-6.4-12.5-16.6-22.7-29.1-29.1 c-14.3-7.3-32.9-7.3-70.3-7.3H140c-37.3,0-56,0-70.3,7.3c-12.5,6.4-22.7,16.6-29.1,29.1C33.3,265.1,33.3,283.7,33.3,321.1z  M500,431.1c0,9.2-7.5,16.7-16.7,16.7s-16.7-7.5-16.7-16.7c0-9.2,7.5-16.7,16.7-16.7S500,421.9,500,431.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet_icon.665d49485047c5101c6fd0a19608fcbe.svg";
export { ForwardRef as ReactComponent };